import PoweredByHarmony from '../PoweredByHarmony';
import CopyKeywords from './CopyKeywords';
import {
  KeywordsContainer,
  KeywordsBox,
  KeywordsHeader,
  KeywordsContent,
  Keyword,
  KeywordText,
  PoweredByHarmonyWrapper,
  CopyKeywordsWrapper,
} from './Keywords.styles';

/**
 * Keywords component that is displayed in the event pane's transcript tab.
 * @param {Array.Array.<String>} keywords - List of keywords.
 */
const Keywords = ({ keywords = [] }) => {
  if (!keywords.length) {
    return null;
  }

  return (
    <KeywordsContainer data-name="keywords-card">
      <KeywordsBox>
        <KeywordsHeader data-name="keywords-header">
          <PoweredByHarmonyWrapper>
            <PoweredByHarmony title="Keywords" />
          </PoweredByHarmonyWrapper>
          <CopyKeywordsWrapper>
            <CopyKeywords keywords={keywords} />
          </CopyKeywordsWrapper>
        </KeywordsHeader>
        <KeywordsContent data-name="keywords-content">
          {keywords.map(keyword => (
            <Keyword key={keyword}>
              <KeywordText data-name={`keyword-${keyword}`}>
                {keyword}
              </KeywordText>
            </Keyword>
          ))}
        </KeywordsContent>
      </KeywordsBox>
    </KeywordsContainer>
  );
};

export default Keywords;
